import { Component, OnInit, Input } from '@angular/core';
import { PruHttpService } from '../../services/pru-http.service';
declare var environment: any;
@Component({
  selector: 'error-msg',
  templateUrl: './error-msg.component.html',
  styleUrls: ['./error-msg.component.scss']
})
export class ErrorMsgComponent implements OnInit {
  @Input() lob?: string = "generic";
  @Input() msgcode?: string = "";
  wcmUrl = "/wps/wcm/connect/UCD_Content/SA-ErrorMSG/";
  errorMsg: any;
  showError: boolean = false;

  constructor(public _pruHttpService: PruHttpService) { }

  ngOnInit() {
    this.lob = this.lob.replace(/\s/g, "");
    const msgUrl = environment.PUBLIC_RENDER_DOMAIN + this.wcmUrl + this.lob + (this.msgcode ? "-" : "") + this.msgcode;
    this._pruHttpService.getText(msgUrl, "wcm-error", "no-headers")
      .subscribe(
        data => {
          this.errorMsg = data;
          this.showError = true;
        },
        error => {
          console.log("ErrorMsg: ", error)
          this.showError = true;
        });
  }
}
